import { TeamsView } from '@/domains/teams/components/TeamsView';
import { useCreateTeam, useTeams } from '@/domains/teams/hooks/useTeams';
import { useNavigate } from 'react-router';

export function TeamsPage() {
  const navigate = useNavigate();
  const { data: teams = [], isLoading, isError } = useTeams();
  const createTeam = useCreateTeam();

  return (
    <TeamsView
      teams={teams}
      isLoading={isLoading}
      isError={isError}
      onTeamClick={(teamId) => navigate(`/teams/${teamId}`)}
      onCreateTeam={async (name, description, maxCapacity, memberIds, teamLeadId) => {
        await createTeam.mutateAsync({
          name,
          ...(description && { description }),
          ...(maxCapacity !== null && { maxCapacity }),
          ...(memberIds.length > 0 && { memberIds }),
          ...(teamLeadId !== null && { teamLeadId }),
        });
      }}
    />
  );
}
